import { Component, OnInit } from '@angular/core';
import {WizardService} from '../../../services/wizard.service';
import {AdditionalLogo, AssetsService} from '../../../../shared/services/assets.service';
import {ConfigurationService} from '../../../services/impl/configuration/configuration.service';
import {env, isCarOne, isMPay, isNestBank, isSkycash} from '../../../utils/utils';
import {ApplicationContextService} from '../../../services/impl/configuration/application-context.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {NextNotificationService} from '../../../services/impl/next-notification.service';

/* Moto 3.0 header */

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class HeaderComponent implements OnInit {

  title = 'HEADER.TITLE';
  titleBadge: string;
  readonly SUBMIT_GOOGLE_REVIEW_URL = 'https://g.page/r/CW_GATDEwqD0EB0/review';

  get additionalLogo(): AdditionalLogo {
    return this.assetsService.getAdditionalLogo();
  }

  get headerConfig() {
    return this.configurationService.uiConfig.headerConfig;
  }

  get logo() {
    return this.headerConfig.logo;
  }

  get navigationVisible(): boolean {
    return !this.wizardService.isNotificationStep && this.contextService.navigationVisible;
  }

  get sendOfferVisible(): boolean {
    return !this.wizardService.isNotificationStep && this.contextService.sendOfferVisible;
  }

  get googleReviewButtonVisible(): boolean {
    return this.wizardService.isNotificationStep && this.contextService.submitGoogleReviewVisible && this.notificationService.submitGoogleReviewButtonVisible;
  }

  get rightContentVisible(): boolean {
    if (isCarOne()) {
      return false;
    }
    return this.sendOfferVisible || this.googleReviewButtonVisible;
  }

  get logoRedirectEnabled(): boolean {
    return !(isSkycash() || isMPay()) && !this.contextService.headerLogoRedirectDisabled && !this.wizardService.headerLogoRedirectDisabled;
  }

  get dividerVisible(): boolean {
    return this.wizardService.resolveElementVisibility(this.logo) && isNotNullOrUndefined(this.title);
  }

  get logosDividerVisible(): boolean {
    return isNestBank() && this.wizardService.resolveElementVisibility(this.logo) && isNotNullOrUndefined(this.additionalLogo);
  }

  constructor(public wizardService: WizardService,
              private configurationService: ConfigurationService,
              private contextService: ApplicationContextService,
              private assetsService: AssetsService,
              private notificationService: NextNotificationService) { }

  ngOnInit() {
    this.initTitle();
    this.initTitleBadge();
  }

  navigateToLP() {
    if (this.logoRedirectEnabled) {
      window.open('https://kioskpolis.pl/', '_blank');
    }
  }

  private initTitle(): void {
    if (isNotNullOrUndefined(this.contextService.headerTitle)) {
      this.title = this.contextService.headerTitle;
    }
    if (isCarOne()) {
      this.title = 'HEADER.CARONE_TITLE';
    }
    if (isNestBank() && !this.wizardService.isNotificationStep) {
      this.title = null;
    }
  }

  private initTitleBadge(): void {
    if (isNotNullOrUndefined(this.contextService.headerTitleBadge)) {
      this.titleBadge = this.contextService.headerTitleBadge;
    }
  }

}
